module.exports = "/src/views/player/help/images/news.jpg";